import { useTranslation } from 'react-i18next';

import { Header } from '../Header';

import { PagePopupProps } from './types';

interface PagePopupHeaderProps
  extends Pick<PagePopupProps, 'onClose' | 'okText' | 'closeIcon' | 'title'> {
  onOk?: () => void;
}

export const PagePopupHeader = (props: PagePopupHeaderProps) => {
  const { t } = useTranslation('global');
  const { title, okText = t('global:m_button_done'), onOk, onClose } = props;

  return (
    <Header
      onBack={onClose}
      right={!!onOk && <Header.TextButton onClick={onOk}>{okText}</Header.TextButton>}
    >
      {title}
    </Header>
  );
};
